.ant-layout-header{font-weight:600;font-size:20px;background-color:#f4f4f6;background:#f4f4f6}nz-content{padding-left:50px;padding-right:50px}.social-history-section{padding-top:64px}
/*# sourceMappingURL=social-history-section.component-Y53ZALKH.css.map */
